import { render } from "./RecommendedProductsManual.vue?vue&type=template&id=7ff972f0"
import script from "./RecommendedProductsManual.vue?vue&type=script&lang=js"
export * from "./RecommendedProductsManual.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__